// 统一谷歌地图 API加载hook
import { useJsApiLoader } from '@react-google-maps/api';
import { getI18nLang } from '@/i18n/settings';

const defaultOptions = {
  language: getI18nLang()
};

export const useGoogleMapsApi = (options?: {
  libraries?: Array<'places' | 'drawing' | 'geometry' | 'localContext' | 'visualization'>;
}) => {
  const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY as string;
  
  const mergedOptions = {
    ...options,
    ...defaultOptions
  };
  
  return useJsApiLoader({
    id: 'pc-jdi-google-map-script', 
    googleMapsApiKey: apiKey,
    ...mergedOptions,
  });
};
